import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import StyledPercent from "./StyledPercent";
import DiscountCardImage from "./DiscountCardImage";
import { addParamsToImage } from "@utils";

const Container = styled.div`
  width: 100%;
  height: 160px;
  box-shadow: 0 20px 80px 0 rgba(119, 121, 132, 0.1);
  background-color: #ffffff;
  display: grid;

  &:hover {
    box-shadow: 0 60px 80px 0 rgba(119, 121, 132, 0.3);
  }
  @media (max-width: 1600px) {
    height: 150px;
  }
  @media (max-width: 1400px) {
    height: 145px;
  }
  @media (max-width: 1300px) {
    height: 160px;
  }
  @media (max-width: 1150px) {
    height: 170px;
  }
  @media (max-width: 1050px) {
    height: 155px;
  }
  @media (max-width: 950px) {
    height: 147px;
  }
  @media (max-width: 925px) {
    height: 170px;
  }
  @media (max-width: 850px) {
    height: 155px;
  }
  @media (max-width: 775px) {
    height: 147px;
  }
  @media (max-width: 700px) {
    height: 137px;
  }
  @media (max-width: 600px) {
    height: 129px;
  }
  @media (max-width: 575px) {
    height: 155px;
  }
  @media (max-width: 375px) {
    height: 131px;
  }
`;

const ImageDiv = styled.div`
  position: absolute;
  top: -47px;
  width: 100%;
  text-align: center;
  @media (max-width: 450px) {
    top: -41px;
  }
`;

const InnerDiv = styled.div`
  position: relative;
`;

const NameDiv = styled.div`
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
  margin-top: 20px;
  margin-bottom: 15px;

  @media (max-width: 700px) {
    margin-top: 7px;
  }
  @media (max-width: 600px) {
    margin-top: 2px;
    margin-bottom: 12px;
  }
  @media (max-width: 575px) {
    margin-top: 28px;
    margin-bottom: 12px;
  }
  @media (max-width: 480px) {
    margin-top: 20px;
  }
  @media (max-width: 400px) {
    margin-top: 20px;
    margin-bottom: 15px;
    padding-right: 3px;
    padding-left: 3px;
  }
  @media (max-width: 375px) {
    margin-top: 10px;
    margin-bottom: 11px;
  }
`;

const CardsLeftMainContainer = styled.div`
  position: relative;
  width: 139px;
  margin: 0 auto;
  @media (max-width: 1750px) {
    width: 66%;
  }
`;

const CardsLeftInnerContainer = styled.div`
  position: absolute;
  width: 86px;
  height: 28px;
  border-radius: 0px 5px 5px 0px;
  background-color: #12b2ea;
  font-size: 10px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #ffffff;
  top: 6px;
  left: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 500px) {
    width: 79px;
  }
  @media (max-width: 500px) {
    width: 69px;
    font-size: 9px;
    height: 25px;
  }
`;

const DiscountCard = ({
  moveToMerchantDetail,
  name,
  img,
  upToPercentage,
  cardsAvailable
}) => {
  const nameLength = name.length;
  let nameSize =
    nameLength > 28 ? "xLarge" : nameLength > 18 ? "large" : "regular";
  const firstName = name.split(" ")[0];
  if (firstName.length > 16) {
    nameSize = "xLarge";
  }
  const image = addParamsToImage(img, "139x90");
  return (
    <Link to={`/buy-gift-cards/${moveToMerchantDetail}/`}>
      <Container className="button-transition-hover-boxShadow">
        <InnerDiv>
          <ImageDiv>
            {cardsAvailable < 20 && cardsAvailable !== 0 ? (
              <CardsLeftMainContainer>
                <CardsLeftInnerContainer>
                  only{" "}
                  {cardsAvailable === 1
                    ? `${cardsAvailable} left`
                    : `${cardsAvailable} left`}
                </CardsLeftInnerContainer>
              </CardsLeftMainContainer>
            ) : (
              ""
            )}

            <DiscountCardImage
              cardsAvailable={cardsAvailable}
              img={image}
              name={name}
            />

            <div>
              <NameDiv className={`discount-card-name-div-${nameSize}`}>
                {name}
              </NameDiv>
              <StyledPercent
                classNames={"discount-card-styled-percent"}
                soldOut={cardsAvailable < 1 ? true : false}
                percentOff={upToPercentage}
                innerSpancolor={upToPercentage > 10 ? "#ff9c1b" : "#777984"}
                styles={{
                  margin: "0 auto",
                  backgroundColor:
                    upToPercentage > 10
                      ? "rgba(255, 156, 27, 0.1)"
                      : "rgba(119, 121, 132, 0.1)",
                  color:
                    upToPercentage > 10
                      ? "rgba(255, 156, 27, 0.7)"
                      : "rgba(119, 121, 132, 0.7)"
                }}
              />
            </div>
          </ImageDiv>
        </InnerDiv>
      </Container>{" "}
    </Link>
  );
};

export default DiscountCard;
